export default [
  {
    service: 'initOfferTokenByType',
    url: '{widgetAPIServerHost}/checkout/rest/v2/transactions/{accessToken}/offer/init',
    method: 'post',
    headers: {
      'Content-Type': 'application/json;charset=utf-8',
    },
    responseType: 'json',
    queryType: 'mutation',
  },
  {
    service: 'optOffer',
    url: '{widgetAPIServerHost}/checkout/rest/v2/transactions/{accessToken}/{offerType}/opt',
    method: 'post',
    headers: {
      'Content-Type': 'application/json;charset=utf-8',
    },
    responseType: 'json',
    queryType: 'mutation',
  },
  {
    service: 'qualifyOffer',
    url: '{widgetAPIServerHost}/checkout/rest/v2/transactions/{accessToken}/{offerType}/qualify',
    method: 'post',
    headers: {
      'Content-Type': 'application/json;charset=utf-8',
    },
    responseType: 'json',
    queryType: 'mutation',
  },
  {
    service: 'removeMagazine',
    url: '{widgetAPIServerHost}/checkout/rest/v2/transactions/{accessToken}/magazine/remove',
    method: 'post',
    headers: {
      'Content-Type': 'application/json;charset=utf-8',
    },
    responseType: 'json',
    queryType: 'mutation',
  },
];
